<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative text-center">
      <p class="text-center">{{ message }}</p>

      <primary-button class="w-32 mt-4" @buttonClicked="close"
        >Aceptar
      </primary-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Information Modal",

  props: {
    message: String,
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>